import SeoArticle from "@/components/SeoArticle";
import {
  PARK_HOME_ASSIST_ALTERNATIVE,
  GOLDSHIELD_ALTERNATIVE,
  PARK_HOME_INSURANCE_ALTERNATIVES,
  BEST_PARK_HOME_SUPPORT_SERVICES,
  MAINTENANCE_PLAN_ALTERNATIVE,
  SERVICE_INSPECTION,
  SERVICE_REPAIRS,
  SERVICE_MAINTENANCE,
  SERVICE_INSURANCE_CLAIM,
  SERVICE_QUOTE_REVIEW,
  LOCATION_ESSEX,
  LOCATION_KENT,
  LOCATION_SUFFOLK,
  LOCATION_NORFOLK,
  LOCATION_CAMBRIDGESHIRE,
  INSPECTIONS_ESSEX, REPAIRS_ESSEX, SURVEYS_KENT, REPAIRS_SUFFOLK, INSURANCE_HELP_NORFOLK, MAINTENANCE_CAMBRIDGESHIRE,
  REPAIRS_COLCHESTER, SURVEYS_CHELMSFORD, SUPPORT_CLACTON,
  INSPECTION_COST, UNDERFLOOR_INSULATION,
  KB_RESPONSIBILITY,
  KB_OPERATOR_REFUSE,
  KB_CLAIM_REJECTED,
  KB_BASE_FAILURE,
  KB_MOBILE_HOMES_ACT,
  KB_DRAINAGE,
} from "@/data/seoContent";

const RELATED_ALL = [
  { to: "/quote-review", label: "Check Your Quote" },
  { to: "/park-home-urgent-repairs", label: "Urgent Repair Guidance" },
  { to: "/inspections", label: "Independent Inspections" },
  { to: "/insurance", label: "Insurance Guidance" },
  { to: "/membership", label: "Join for £99" },
];

const wrap = (data, extraRelated = []) => () =>
  <SeoArticle {...data} related={[...extraRelated, ...RELATED_ALL].slice(0, 5)} />;

// Competitor comparison pages
export const ParkHomeAssistAlternative = wrap(PARK_HOME_ASSIST_ALTERNATIVE, [
  { to: "/park-home-insurance-alternatives", label: "Insurance Alternatives" },
  { to: "/best-park-home-support-services", label: "Compare Services" },
]);
export const GoldshieldAlternative = wrap(GOLDSHIELD_ALTERNATIVE, [
  { to: "/park-home-assist-alternative", label: "Park Home Assist Alternative" },
  { to: "/best-park-home-support-services", label: "Compare Services" },
]);
export const ParkHomeInsuranceAlternatives = wrap(PARK_HOME_INSURANCE_ALTERNATIVES, [
  { to: "/park-home-insurance-claims-advice", label: "Insurance Claims Advice" },
  { to: "/park-home-insurance-claim-support", label: "Insurance Claim Support" },
]);
export const BestParkHomeSupportServices = wrap(BEST_PARK_HOME_SUPPORT_SERVICES, [
  { to: "/park-home-assist-alternative", label: "Park Home Assist Alternative" },
  { to: "/goldshield-alternative", label: "GoldShield Alternative" },
]);

// Service pages
export const ParkHomeInspection = wrap(SERVICE_INSPECTION, [
  { to: "/park-home-repairs", label: "Park Home Repairs" },
  { to: "/park-home-quote-review-service", label: "Quote Review" },
]);
export const ParkHomeRepairs = wrap(SERVICE_REPAIRS, [
  { to: "/park-home-inspection", label: "Park Home Inspection" },
  { to: "/park-home-repair-costs-uk", label: "Repair Costs UK" },
]);
export const ParkHomeMaintenance = wrap(SERVICE_MAINTENANCE, [
  { to: "/park-home-inspection", label: "Park Home Inspection" },
  { to: "/park-home-base-failure-signs", label: "Base Failure Signs" },
]);
export const ParkHomeInsuranceClaimSupport = wrap(SERVICE_INSURANCE_CLAIM, [
  { to: "/park-home-insurance-claim-rejected", label: "Claim Rejected?" },
  { to: "/park-home-insurance-alternatives", label: "Insurance Alternatives" },
]);
export const ParkHomeQuoteReview = wrap(SERVICE_QUOTE_REVIEW, [
  { to: "/park-home-repairs", label: "Park Home Repairs" },
  { to: "/park-home-quote-too-high", label: "Is Your Quote Too High?" },
]);

// Location pages
export const LocationEssex = wrap(LOCATION_ESSEX, [
  { to: "/park-home-support-kent", label: "Kent" },
  { to: "/park-home-support-suffolk", label: "Suffolk" },
]);
export const LocationKent = wrap(LOCATION_KENT, [
  { to: "/park-home-support-essex", label: "Essex" },
  { to: "/park-home-support-suffolk", label: "Suffolk" },
]);
export const LocationSuffolk = wrap(LOCATION_SUFFOLK, [
  { to: "/park-home-support-norfolk", label: "Norfolk" },
  { to: "/park-home-support-essex", label: "Essex" },
]);
export const LocationNorfolk = wrap(LOCATION_NORFOLK, [
  { to: "/park-home-support-suffolk", label: "Suffolk" },
  { to: "/park-home-support-cambridgeshire", label: "Cambridgeshire" },
]);
export const LocationCambridgeshire = wrap(LOCATION_CAMBRIDGESHIRE, [
  { to: "/park-home-support-norfolk", label: "Norfolk" },
  { to: "/park-home-support-suffolk", label: "Suffolk" },
]);

// Knowledge centre articles
export const KbResponsibility = wrap(KB_RESPONSIBILITY, [
  { to: "/can-park-operator-refuse-repairs", label: "Operator Refused Repairs?" },
  { to: "/understanding-mobile-homes-act", label: "Mobile Homes Act" },
]);
export const KbOperatorRefuse = wrap(KB_OPERATOR_REFUSE, [
  { to: "/who-is-responsible-for-park-home-repairs", label: "Repair Responsibility" },
  { to: "/understanding-mobile-homes-act", label: "Mobile Homes Act" },
]);
export const KbClaimRejected = wrap(KB_CLAIM_REJECTED, [
  { to: "/park-home-insurance-claim-support", label: "Claim Support" },
  { to: "/park-home-insurance-claims-advice", label: "Insurance Claims Advice" },
]);
export const KbBaseFailure = wrap(KB_BASE_FAILURE, [
  { to: "/park-home-drainage-problems", label: "Drainage Problems" },
  { to: "/park-home-inspection", label: "Park Home Inspection" },
]);
export const KbMobileHomesAct = wrap(KB_MOBILE_HOMES_ACT, [
  { to: "/who-is-responsible-for-park-home-repairs", label: "Repair Responsibility" },
  { to: "/can-park-operator-refuse-repairs", label: "Operator Refused Repairs?" },
]);
export const KbDrainage = wrap(KB_DRAINAGE, [
  { to: "/park-home-base-failure-signs", label: "Base Failure Signs" },
  { to: "/park-home-inspection", label: "Park Home Inspection" },
]);

// Additional competitor alternative
export const MaintenancePlanAlternative = wrap(MAINTENANCE_PLAN_ALTERNATIVE, [
  { to: "/best-park-home-support-services", label: "Compare Services" },
  { to: "/park-home-insurance-alternatives", label: "Insurance Alternatives" },
]);

// Service+location pages
export const InspectionsEssex = wrap(INSPECTIONS_ESSEX, [
  { to: "/park-home-support-essex", label: "Essex Overview" },
  { to: "/park-home-inspection", label: "Park Home Inspection" },
]);
export const RepairsEssex = wrap(REPAIRS_ESSEX, [
  { to: "/park-home-support-essex", label: "Essex Overview" },
  { to: "/park-home-repairs", label: "Park Home Repairs" },
]);
export const SurveysKent = wrap(SURVEYS_KENT, [
  { to: "/park-home-support-kent", label: "Kent Overview" },
  { to: "/park-home-inspection", label: "Park Home Inspection" },
]);
export const RepairsSuffolk = wrap(REPAIRS_SUFFOLK, [
  { to: "/park-home-support-suffolk", label: "Suffolk Overview" },
  { to: "/park-home-repairs", label: "Park Home Repairs" },
]);
export const InsuranceHelpNorfolk = wrap(INSURANCE_HELP_NORFOLK, [
  { to: "/park-home-support-norfolk", label: "Norfolk Overview" },
  { to: "/park-home-insurance-claim-support", label: "Insurance Claim Support" },
]);
export const MaintenanceCambridgeshire = wrap(MAINTENANCE_CAMBRIDGESHIRE, [
  { to: "/park-home-support-cambridgeshire", label: "Cambridgeshire Overview" },
  { to: "/park-home-maintenance", label: "Park Home Maintenance" },
]);

// City pages
export const RepairsColchester = wrap(REPAIRS_COLCHESTER, [
  { to: "/park-home-repairs-essex", label: "Park Home Repairs in Essex" },
  { to: "/park-home-support-essex", label: "Essex Overview" },
]);
export const SurveysChelmsford = wrap(SURVEYS_CHELMSFORD, [
  { to: "/park-home-inspections-essex", label: "Park Home Inspections in Essex" },
  { to: "/park-home-support-essex", label: "Essex Overview" },
]);
export const SupportClacton = wrap(SUPPORT_CLACTON, [
  { to: "/park-home-repairs-essex", label: "Park Home Repairs in Essex" },
  { to: "/park-home-support-essex", label: "Essex Overview" },
]);

// Intent-specific problem pages
export const InspectionCost = wrap(INSPECTION_COST, [
  { to: "/park-home-inspection", label: "Park Home Inspection Service" },
  { to: "/park-home-base-failure-signs", label: "Base Failure Signs" },
]);
export const UnderfloorInsulation = wrap(UNDERFLOOR_INSULATION, [
  { to: "/park-home-damp-problems", label: "Damp Problems" },
  { to: "/park-home-drainage-problems", label: "Drainage Problems" },
]);
